<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent:0em;">To Captain William Warner Julius (Acting Major &amp; C.O. of the 2/15th Field Regiment, 8th Australian Division, DX141), brother to Doreen Hope Wood and the author’s great-uncle, K.I.A. at the battle of Muar, Malaya, 23 January 1942.</p><br/>
<p style="text-indent:0em;">This book is also dedicated to the men of the 39th Battalion and 21st Brigade who stopped the Japanese at Australia’s Thermopylae.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?7f14a791